import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { EnumService } from "src/app/components/shared/services/enum.service";
import { ProductService } from "src/app/components/shared/services/product.service";
import { ItemsEcCat } from "src/app/modals/items-ec-cat";
import { Product } from "src/app/modals/product.model";
import { ItemsService } from "src/app/services/items.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-product-vertical",
  templateUrl: "./product-vertical.component.html",
  styleUrls: ["./product-vertical.component.sass"],
})
export class ProductVerticalComponent implements OnInit {
  //  @Input() products: any;
  @Input()
  set products(value: any) {
    if (typeof value.itemsEcCat != "undefined") {
      if (typeof value.itemsEcCat.itemsEC_Cat1 != "undefined") {
        this._products.itemsEC_Cat1 = value.itemsEcCat.itemsEC_Cat1;
        value.itemsEcCat.itemsEC_Cat1.forEach((el) => {
          this.cat1.push({
            idItemEC: el.idItemEC,
            TItemEC: el.TItemEC,
            TItemECNom: el.TItemECNom,
            idItem: el.idItem,
            Marca: el.Marca,
            Codigo: el.Codigo,
            Nro: el.Nro,
            NombreItm: el.NombreItm.substring(0, 20),
            UniMed: el.UniMed,
            UniMedDeno: el.UniMedDeno,
            CodigoBarras: el.CodigoBarras,
            PV1: el.PV1,
            PV2: el.PV2,
            PV3: el.PV3,
            PV4: el.PV4,
            PV5: el.PV5,
            PV6: el.PV6,
            PorcDscto: el.PorcDscto,
            Otros: el.Otros,
            ImagenP: el.ImagenP,
            ClicCant: el.ClicCant,
            ValCant: el.ValCant,
            ValSum: el.ValSum,
            ValProm: el.ValProm,
            Habilitado: el.Habilitado,
            Mostrar: el.Mostrar,
            OrdenIEC: el.OrdenIEC,
          });
        });
      }
      if (typeof value.itemsEcCat.itemsEC_Cat2 != "undefined") {
        //this._products.itemsEC_Cat2 = value.itemsEcCat.itemsEC_Cat2;
        value.itemsEcCat.itemsEC_Cat2.forEach((el) => {
          this.cat2.push({
            idItemEC: el.idItemEC,
            TItemEC: el.TItemEC,
            TItemECNom: el.TItemECNom,
            idItem: el.idItem,
            Marca: el.Marca,
            Codigo: el.Codigo,
            Nro: el.Nro,
            NombreItm: el.NombreItm.substring(0, 20),
            UniMed: el.UniMed,
            UniMedDeno: el.UniMedDeno,
            CodigoBarras: el.CodigoBarras,
            PV1: el.PV1,
            PV2: el.PV2,
            PV3: el.PV3,
            PV4: el.PV4,
            PV5: el.PV5,
            PV6: el.PV6,
            PorcDscto: el.PorcDscto,
            Otros: el.Otros,
            ImagenP: el.ImagenP,
            ClicCant: el.ClicCant,
            ValCant: el.ValCant,
            ValSum: el.ValSum,
            ValProm: el.ValProm,
            Habilitado: el.Habilitado,
            Mostrar: el.Mostrar,
            OrdenIEC: el.OrdenIEC,
          });
        });
      }
      if (typeof value.itemsEcCat.itemsEC_Cat3 != "undefined") {
        //this._products.itemsEC_Cat3 = value.itemsEcCat.itemsEC_Cat3;
        value.itemsEcCat.itemsEC_Cat3.forEach((el) => {
          this.cat3.push({
            idItemEC: el.idItemEC,
            TItemEC: el.TItemEC,
            TItemECNom: el.TItemECNom,
            idItem: el.idItem,
            Marca: el.Marca,
            Codigo: el.Codigo,
            Nro: el.Nro,
            NombreItm: el.NombreItm.substring(0, 20),
            UniMed: el.UniMed,
            UniMedDeno: el.UniMedDeno,
            CodigoBarras: el.CodigoBarras,
            PV1: el.PV1,
            PV2: el.PV2,
            PV3: el.PV3,
            PV4: el.PV4,
            PV5: el.PV5,
            PV6: el.PV6,
            PorcDscto: el.PorcDscto,
            Otros: el.Otros,
            ImagenP: el.ImagenP,
            ClicCant: el.ClicCant,
            ValCant: el.ValCant,
            ValSum: el.ValSum,
            ValProm: el.ValProm,
            Habilitado: el.Habilitado,
            Mostrar: el.Mostrar,
            OrdenIEC: el.OrdenIEC,
          });
        });
      }
    }
  }
  _products: ItemsEcCat = new ItemsEcCat();
  cat1: any[] = [];
  cat2: any[] = [];
  cat3: any[] = [];
  bannerGamer: any[] = [];
  bannerGamerMovil: any[] = [];
  private loader: boolean = true;
  esMovil: boolean = false;
  constructor(
    private productService: ProductService,
    private router: Router,
    private itemService: ItemsService,
    private enumService: EnumService
  ) {}

  ngOnInit() {
    this.cargarBanner();
    // this.productService.getProducts()
    //   .subscribe(
    //     product => this.products = product
    //   )
  }
  ngDoCheck() {
    this.cambiarBanner();
  }
  async selectItem(idItem) {
    await this.itemService.sumarClic(idItem)
    this.router.navigate(["/home/product", idItem]);
  }
  cargarBanner() {
    this.enumService.getBannerGamer().subscribe((resp: any) => {
      this.bannerGamer = resp.filter((x) => x.AccionBanner != "bannerMovil");
      this.bannerGamerMovil = resp.filter(
        (x) => x.AccionBanner == "bannerMovil"
      );
      this.cambiarBanner();
    });
  }
  cambiarBanner() {
    let tamaño = window.innerWidth;
    if (tamaño <= 600) {
      this.esMovil = true;
    } else {
      this.esMovil = false;
    }
  }
  irATodoGamer() {
    let paramNomItem = {
      param1: "gamer",
      param2: "",
      param3: "",
    };
    sessionStorage.setItem("paramFilter", JSON.stringify(paramNomItem));
    sessionStorage.setItem("marca","TODAS")
    this.router.navigate(["/home/products", 0,0,"gamer", "TODAS", 0,0,1]);
    document.title = "Zona Gamer | Novaplaza"
    sessionStorage.setItem("titleNav","Zona Gamer")
    this.enumService.setTitleMeta("Zona Gamer | Novaplaza", {
      name: "description",
      content:"Ofrecemos las mejores componentes para tu zona gamer en Arequipa"
    });
  }
}
